import jQuery from 'jquery'
import 'slick-carousel'

export default class OffersNav {
  constructor(element) {
    if (!element) {
      return false
    }

    this.$element = jQuery(element)
    this.slider = jQuery('.s-offers-nav__results', this.$element)

    if (!this.slider.hasClass('slickCarousel_dsk-3_md-2_sm-1')) {
      return false
    }

    this.slider.slick({
      dots: true,
      arrows: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    })
  }
}
